import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import User from './views/User.vue';
import Map from './views/Map.vue';
import GeoDanmarkApi from '@/api/GeoDanmark';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/map',
      name: 'map',
      // route level code-splitting
      // this generates a separate chunk (map.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "map" */ './views/Map.vue'),
      component: Map,
    },
    {
      path: '/user',
      name: 'user',
      component: User,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'home' && (!localStorage.getItem('token'))) {
    store.commit('setLoading', false);
    next('/');
    // todo: returnUrl should work after login (now being errored by geodanmark login-page)
    // next(`/?returnUrl=${to.fullPath}`);
  } else if (to.name !== 'home') {
    GeoDanmarkApi.getMe(localStorage.getItem('token'))
      .then(user => {
        store.commit('updateUser', user);
        store.commit('setLoading', false);
        next();
      })
      .catch(() => {
        store.commit('updateUser', null);
        localStorage.removeItem('token');
        next('/');
      });
  } else {
    next();
  }
});

export default router;
